import {useSelector} from "react-redux";
import {financeSelector} from "../../../../redux/slices/financeSlice";
import {globalDataSelector} from "../../../../redux/slices/globalDataSlice";
import {useTranslation} from "react-i18next";
// import s from "../ConfirmPopup/confirmPopup.module.scss";
import s from './subscriptionActivatedPopup.module.scss'
import React, {useEffect} from "react";
import SvgSelector from "../../../SvgSelector/SvgSelector";
import SliderLoader from "../../Loader/SliderLoader/SliderLoader";
import CancelButton from "../../Buttons/CancelBtn/CancelBtn";
import PrimaryBtn from "../../Buttons/PrimaryBorderBtn/PrimaryBorderBtn";
import {snackbar_info} from "../../../../utils/vars/staticVariables";
import BaseTextInput from "../../../BaseTextInput/BaseTextInput";

const SubscriptionActivatedPopup = ({
                          active,
                          setActive,
                          action,
                          description,
                          subDescription1,
                          subDescription2,
                          title,
                          confirmBtnText,
                          forcedClose = true,
                          icon,
                          notifyingMode = false,
                          notifyingModeAction,
                          pending,
                                        notifyingModePopupData
                      }) => {
    const {topUpBalanceIsActive} = useSelector(financeSelector);
    const {exitPopup, isCollapsedSidebar} = useSelector(globalDataSelector);

    const {t} = useTranslation();

    const handleClosePopup = (event) => {
        if (event.target.classList.contains(s.popupWrapper)) {
            setActive(false);
        }
    };

    useEffect(() => {
        if ((forcedClose && topUpBalanceIsActive) || (forcedClose && exitPopup)) {
            setActive(false);
        }
    }, [topUpBalanceIsActive, exitPopup]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (pending === undefined) {
            setActive(false);
        }
        action();
    };

    useEffect(() => {
        const handleEscClose = (e) => {
            if (e.key === "Escape") {
                setActive(false);
                if (document.activeElement) {
                    document.activeElement.blur();
                }
            }
        };
        const handleEnterPress = (e) => {
            if (e.key === "Enter") {
                if (document.activeElement) {
                    document.activeElement.blur();
                }
                handleSubmit(e);
            }
        };
        if (active) {
            document.addEventListener("keydown", handleEscClose);
            document.addEventListener("keydown", handleEnterPress);
        }

        return () => {
            document.removeEventListener("keydown", handleEscClose);
            document.removeEventListener("keydown", handleEnterPress);
        };
    }, [active]);

    return (
        <form
            onSubmit={handleSubmit}
            className={`${s.popupWrapper} ${active ? s.active : ""} ${isCollapsedSidebar === "true" ? s.collapsed : ""}`}
            onClick={handleClosePopup}
        >
            <div className={active ? `${s.popup} ${s.active}` : s.popup}>
                <button
                    onClick={() => setActive(false)}
                    className={s.closePopup}
                    type="button"
                >
                    <SvgSelector id="close-popup"/>
                </button>
                <div className={s.bodyContainer}>
                    <span className={s.iconWrapper}>{icon}</span>
                    <p className={s.title}>{title}</p>
                    <div className={s.descriptionsContainer}>
                        <p className={s.mainDescription}>{description}</p>
                        {
                            (subDescription1 || subDescription2) && <div className={s.subdescriptionsContainer}>
                                {
                                    subDescription1 && <p className={s.subdescription}>{subDescription1}</p>
                                }
                                {
                                    subDescription2 && <p className={s.subdescription}>{subDescription2}</p>
                                }
                            </div>
                        }
                    </div>
                    {
                        pending && <div className={s.loaderWrapper}>
                            <SliderLoader/>
                        </div>
                    }
                    {
                        notifyingModePopupData?.subscription_name === 'Wild Star' &&
                        notifyingModePopupData?.secret_key &&

                        <div className={s.copyInputContainer}>
                            <p className={s.inputDesc}>{t("copy_the_secret_key")}:</p>
                            <BaseTextInput
                                value={notifyingModePopupData?.secret_key}
                                placeholder='Secret key'
                                copy={true}
                                alertMessage={t("secret_key_copied")}
                                alertType={snackbar_info}
                            />
                        </div>
                    }
                </div>
                <div className={s.footer}>
                    <CancelButton
                        text={t('close')}
                        action={() => {
                            if (notifyingMode && notifyingModeAction) {
                                notifyingModeAction()
                            } else {

                                setActive(false)
                            }
                        }}
                        width={120}
                    />

                    {
                        !notifyingMode && <PrimaryBtn pending={pending} text={confirmBtnText} submit={true}/>
                    }
                </div>
            </div>
        </form>
    );
};

export default SubscriptionActivatedPopup;
